import { gql } from "@apollo/client";

export const FEED_LOCATION = gql`
  mutation Feed($domain: String!, $locationid: Int!, $overwriteFeedcurve: Boolean!, $amount: Int!) {
    location {
      feed(domain: $domain, locationid: $locationid, overwriteFeedcurve: $overwriteFeedcurve, amount: $amount) {
        code
        success
        message
      }
    }
  }
`

export interface FeedLocation {
  domain: string
  locationid: number
  overwriteFeedcurve: boolean
  amount: number
}

interface FeedLocationAction {
  code: String
  success: Boolean
  message: string
}

export interface FeedLocationResponse {
  location: {
    feed: FeedLocationAction
  }
}